module.exports = __webpack_public_path__ + "img/img_exterior03.24fcb143.jpg";